import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "资讯", to: "/news" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
    setSearchOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    [
      "rounded-md px-3 py-2 text-sm font-medium transition-colors",
      isActive
        ? "bg-primary-50 text-primary-700"
        : "text-foreground-700 hover:bg-background-200 hover:text-foreground-950",
    ].join(" ");

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 items-center gap-3 px-4 md:h-[72px] md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-film-line text-xl" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-extrabold tracking-tight text-foreground-950">
              麻豆精品
            </span>
            <span className="mt-0.5 hidden text-[11px] font-medium tracking-wide text-foreground-500 sm:block">
              MODOU PREMIUM · 影视资讯
            </span>
          </span>
        </Link>

        <nav className="ml-6 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form
          onSubmit={handleSearch}
          className="ml-auto hidden items-center gap-2 md:flex"
          role="search"
        >
          <div className="relative">
            <i
              className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"
              aria-hidden="true"
            ></i>
            <input
              type="search"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索电影、电视剧、资讯…"
              className="h-10 w-56 rounded-full border border-background-300 bg-background-100 pl-9 pr-4 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50 lg:w-64"
            />
          </div>
          <button
            type="submit"
            className="h-10 shrink-0 cursor-pointer whitespace-nowrap rounded-full bg-accent-500 px-4 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-600"
          >
            搜索
          </button>
        </form>

        <div className="ml-auto flex items-center gap-2 md:hidden">
          <button
            type="button"
            onClick={() => setSearchOpen((prev) => !prev)}
            aria-label="打开搜索"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:bg-background-200"
          >
            <i className="ri-search-line text-lg" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="打开菜单"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:bg-background-200"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {searchOpen && (
        <div className="border-t border-background-200/80 px-4 py-3 md:hidden">
          <form onSubmit={handleSearch} className="flex items-center gap-2">
            <div className="relative flex-1">
              <i
                className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"
                aria-hidden="true"
              ></i>
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索电影、电视剧、资讯…"
                className="h-10 w-full rounded-full border border-background-300 bg-background-100 pl-9 pr-4 text-sm text-foreground-900 outline-none focus:border-primary-400 focus:bg-background-50"
              />
            </div>
            <button
              type="submit"
              className="h-10 shrink-0 cursor-pointer whitespace-nowrap rounded-full bg-accent-500 px-4 text-sm font-semibold text-foreground-950"
            >
              搜索
            </button>
          </form>
        </div>
      )}

      {menuOpen && (
        <nav className="border-t border-background-200/80 bg-background-50 px-4 py-3 md:hidden">
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === "/"}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    [
                      "flex items-center justify-between rounded-lg px-3 py-2.5 text-sm font-medium",
                      isActive
                        ? "bg-primary-50 text-primary-700"
                        : "text-foreground-700 hover:bg-background-200",
                    ].join(" ")
                  }
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
}